/**
 * The supply list card (Today rail, For You). CleanCleaver does not place supply orders and takes no fee: it keeps the
 * list of what is low, and one tap opens Order, where "Send the list" hands it to the owner's OWN supplier. Managers and
 * owners only (staff have no use for it). The words for a need are core ORDER_STATUS: On the list, Sent, Got it.
 */
import { orderNeeds, ORDER_STATUS } from "@logwave/core";
import { useLoad } from "../lib/useLoad.ts";
import { useApi, useSession } from "../session.tsx";
import { Card, ErrorBox, LinkButton, Skeleton } from "./ui.tsx";

export function SupplyListCard({ version = 0 }: { version?: number }) {
  const api = useApi();
  const s = useSession();
  const manager = s.can("manager");
  const data = useLoad(async () => (manager ? orderNeeds(await api.ordering(s.org.id, s.location.id)) : null), [api, s.org.id, s.location.id, manager, version]);
  if (!manager) return null;
  if (!data.data) return <Card className="order"><p className="kicker">Supply list</p>{data.error ? <ErrorBox error={data.error} onRetry={data.reload} /> : <Skeleton rows={2} />}</Card>;
  const n = data.data;
  return (
    <Card className="order" as="div">
      <p className="kicker">Supply list</p>
      {n.count === 0 ? (
        <>
          <p className="muted small">Nothing to order. Supplies are at par.</p>
          <LinkButton to="/order" variant="secondary" small icon="cart">Open the list</LinkButton>
        </>
      ) : (
        <>
          <p className="small"><strong>{ORDER_STATUS.list}:</strong> {n.names.slice(0, 4).join(", ")}{n.count > 4 ? ` and ${n.count - 4} more` : ""}.</p>
          <LinkButton to="/order" small icon="cart">Send the list</LinkButton>
          <p className="caption">You send it to your own supplier. We never order for you.</p>
        </>
      )}
    </Card>
  );
}
